<div
    class="container-fluid well"
    data-test-automation="survey-details">
    <h5>{{title}}</h5>

    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                <!-- Special Survey Area -->
                <div class="col-xs-4">
                    <label class="control-label required-input">Declared as special survey area</label>
                    <div class="input-group">
                        @for (option of ssaValues; track option; let i = $index) {
                            <label class="nlr-radio">
                                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                    <input
                                        #ssaInput="ngModel"
                                        type="radio"
                                        [id]="'ssa'+i"
                                        [name]="'ssa'+i"
                                        [disabled]="!option.active || readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                        [value]="option.value"
                                        [ngModel]="getModel().ssa"
                                        (ngModelChange)="ssaChange(option.value)"
                                        [ngClass]="{'has-radio-error': ssaInput | formFieldHasError}"
                                        required="true" />
                                }
                                <span>{{option.displayValue}}</span>
                            </label>
                        }
                    </div>
                </div>

                <!-- Survey Method -->
                <div class="col-xs-4">
                    <label
                        class="control-label required-input"
                        for="surveyMethod"
                        >Survey method</label
                    >
                    <div
                        class="input-group"
                        data-test-automation="survey-method">
                        <ng-select
                            class="nlr-ng-select"
                            [searchable]="false"
                            [clearable]="false"
                            [ngClass]="{'has-error': surveyMethod | formFieldHasError}"
                            [disabled]="getModel().ssa === undefined || readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                            name="surveyMethod"
                            id="surveyMethod"
                            #surveyMethod="ngModel"
                            placeholder="Select"
                            [items]="surveyMethods"
                            bindLabel="name"
                            [ngModel]="getModel().surveyMethod"
                            (change)="surveyMethodChange($event)"
                            (close)="surveyMethodCloseTooltip()"
                            required>
                            <ng-template
                                ng-option-tmp
                                let-item="item">
                                <div
                                    [nlrTooltip]="item.toolTip"
                                    [nlrTooltipPosition]="'top'"
                                    [nlrTooltipParent]="'surveyMethod'"
                                    >{{item.name}}</div
                                >
                            </ng-template>
                        </ng-select>
                    </div>
                </div>

                <!-- Projected Coordinate System -->
                <div class="col-xs-4">
                    <nlr-projected-coord-system />
                </div>
            </div>
        </div>
    </div>
    <!--<div class="help-block">-->
    <!--    <span>Error!</span>-->
    <!--    <span>Invalid Survey Details</span>-->
    <!--</div>-->
</div>
